<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ngx-skeleton-loader *ngIf="loading" [theme]="{ height: '150px' }">
  </ngx-skeleton-loader>
  <div class="app__content message" *ngIf="!loading">
    <div class="message__header">
      <div class="message__image">
        <img
          *ngIf="whitelabelIcon"
          [src]="whitelabelIcon"
          appImgFallback
          width="40"
          height="40"
          alt="{{ whitelabelName }}"
        />
      </div>
      <div class="message__info">
        <h1>{{ whitelabelName }}</h1>
        <span>{{ message.createdAt | date:'longDate' }}</span>
      </div>
      <div
        tabindex="0"
        role="button"
        class="message__share"
        (click)="share()"
        *ngIf="canShare"
        [attr.aria-label]="'button.share' | translate"
      >
        <span
          aria-hidden="true"
          [inlineSVG]="'/assets/icons/card/share.svg'"
        ></span>
      </div>
    </div>

    <div class="message__content">
      <h2>{{ message.title ? message.title : message.titleText }}</h2>
      <div [innerHTML]="message.contentText"></div>
    </div>
  </div>
</ion-content>
